export default class HtvApiError extends Error {
    constructor(code, title, description = null) {
        super(title);
        this.code = code;
        this.title = title;
        this.description = description;
    }
}
